import React from "react";
import Section from "../components/Section";

function Tutorials() {
  return (
    <div className="page-container">
      {/* Header Image */}
      <img
        src="./tutorials/Tutorials_header.png"
        alt="Tutorials"
        className="header-img"
      />

      {/* Online Tutorials */}
      <h1 className="section-header">Online Tutorials</h1>

      <Section
        header={<h2 className="sub-header">T02 - Academic Paper Reviewing (W02)</h2>}
        content={
          <div className="section-text">
            <div className="video-wrapper">
              <iframe
                src="https://vimeo.com/showcase/10119084/embed"
                title="T02 - Academic Paper Reviewing"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        }
      />

      {/* In-person Tutorials */}
      <h1 className="section-header">In-person Tutorials</h1>
      <Section header={<h2 className="sub-header">T01 - Interaction Design (W02)</h2>} />
      <Section header={<h2 className="sub-header">T03A - Programming Basics (W03)</h2>} />
      <Section header={<h2 className="sub-header">T03B - Advanced Programming (W03)</h2>} />
      <Section header={<h2 className="sub-header">T04 - Electronics Workshop (W05)</h2>} />
      <Section header={<h2 className="sub-header">T05 - CAD/3D Design Workshop (W07)</h2>} />
      <Section header={<h2 className="sub-header">T06 - Physical Fabrication (W09)</h2>} />
      <Section header={<h2 className="sub-header">T07 - Demo Video Production (W10)</h2>} />
      <Section header={<h2 className="sub-header">T08 - Academic Paper Writing (W11)</h2>} />

      {/* Extra Tutorials */}
      <h1 className="section-header">Extra Tutorials</h1>

      <Section
        header={<h2 className="sub-header">Introduction to Unreal</h2>}
        content={
          <div className="section-text">
            <div className="video-wrapper">
              <iframe
                src="https://vimeo.com/showcase/9213768/embed"
                title="Extra Tutorials 1"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        }
      />  
      <Section 
        header={<h2 className="sub-header">Unreal Programming</h2>}
        content={
          <div className="section-text">
            <div className="video-wrapper">
              <iframe
                src="https://vimeo.com/showcase/9234668/embed"
                title="Extra Tutorials 2"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        }
      />
    </div>
  );
}

export default Tutorials;
